module.exports = __webpack_public_path__ + "img/circled-arrow-right.512db443.svg";